'use client';

import { usePathname } from 'next/navigation';
import NavbarRenderer from './NavbarRenderer';
import {
  getDashboardPathForUser,
  getNavbarAuthPath,
  isNavbarHrefActive,
  NavbarVariant,
} from './navbarShared';
import { useMarketingUser } from './useMarketingUser';

type MarketingNavbarProps = {
  variant?: NavbarVariant;
};

export default function MarketingNavbar({ variant = 'default' }: MarketingNavbarProps) {
  const pathname = usePathname();
  // Post-hydration session check (preserves ISR — null on SSR/first render).
  const user = useMarketingUser();

  const authHref = getNavbarAuthPath(pathname);

  const menuItems = [
    {
      href: '/about/patients',
      label: 'For Patients',
      isActive: isNavbarHrefActive(pathname, '/about/patients'),
    },
    {
      href: '/about/providers',
      label: 'For Providers',
      isActive: isNavbarHrefActive(pathname, '/about/providers'),
    },
    {
      href: '/about/sponsors',
      label: 'For Biopharma',
      isActive: isNavbarHrefActive(pathname, '/about/sponsors'),
    },
    {
      href: '/about/about-us',
      label: 'About Us',
      isActive: isNavbarHrefActive(pathname, '/about/about-us'),
    },
    {
      href: '/about/faq',
      label: 'FAQ',
      isActive: isNavbarHrefActive(pathname, '/about/faq'),
    },
    {
      href: '/about/contact-us',
      label: 'Contact Us',
      isActive: isNavbarHrefActive(pathname, '/about/contact-us'),
    },
    {
      href: '/blog',
      label: 'Blog',
      isActive: isNavbarHrefActive(pathname, '/blog'),
    },
  ];

  return (
    <NavbarRenderer
      variant={variant}
      className="marketing-navbar"
      topClassName="top-0"
      menuItems={menuItems}
      authHref={authHref}
      labels={{
        loginOrSignUp: 'Login or Sign Up',
        loginOrCreateAccount: 'Login or Create an Account',
        logout: 'Logout',
        myProfile: 'My Profile',
        goToDashboard: 'Go to Dashboard',
      }}
      user={user}
      dashboardHref={getDashboardPathForUser(user)}
    />
  );
}
